import { AuthedPage, HeaderFooterLayout } from '../app';
import LeftNavPanel from './LeftNavPanel';

const Dashboard = ({ children }: { children: React.ReactElement }) => {
  return (
    <AuthedPage>
      <HeaderFooterLayout useDashboardHeader>
        <div className='mb-2 flex flex-col sm:flex-row max-w-[1440px] mx-auto '>
          <div className='hidden md:block'>
            <LeftNavPanel />
          </div>
          <div className='contents mt-1.5'>{children}</div>
        </div>
      </HeaderFooterLayout>
    </AuthedPage>
  );
};

export default Dashboard;
